var _style, _g, _g2, _g3, _g4, _g5, _g6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatbot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 26 26",
    style: {
      enableBackground: "new 0 0 26 26"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:none;stroke:#000000;stroke-width:1.68;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st2{stroke:#000000;stroke-width:1.68;stroke-linecap:square;stroke-miterlimit:10;}\r\n\t.st3{fill:none;stroke:#000000;stroke-width:1.68;stroke-miterlimit:10;}\r\n\t.st4{opacity:0.6314;}\r\n\t.st5{opacity:0.9804;}\r\n\t.st6{fill:none;stroke:#000000;stroke-width:1.68;stroke-linecap:square;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_9"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.59,1.68c4.26,0,7.73,3.47,7.73,7.73v13.72c-1.53-1.03-3.38-2.3-4.49-3.06c-1.42-0.97-1.42-0.97-1.94-0.97l-8.49-0.05 c-4.26,0-7.73-3.47-7.73-7.73V9.41c0-4.26,3.47-7.73,7.73-7.73H16.59 M16.59,0H9.41C4.21,0,0,4.21,0,9.41v1.91 c0,5.19,4.21,9.41,9.41,9.41l8.48,0.05c0.01,0,3.75,2.57,6.15,4.18c0.22,0.15,0.46,0.22,0.7,0.22c0.66,0,1.27-0.53,1.27-1.27V9.41 C26,4.21,21.79,0,16.59,0L16.59,0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.91,9l0-1.18c0-0.14,0.11-0.25,0.25-0.25l13.68-0.01c0.14,0,0.25,0.11,0.25,0.25l0,1.18c0,0.14-0.11,0.25-0.25,0.25 L6.16,9.25C6.02,9.25,5.91,9.14,5.91,9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.91,13.98l0-1.18c0-0.14,0.11-0.25,0.25-0.25l13.68-0.01c0.14,0,0.25,0.11,0.25,0.25l0,1.18c0,0.14-0.11,0.25-0.25,0.25 L6.16,14.23C6.02,14.23,5.91,14.12,5.91,13.98z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatbot);
export default __webpack_public_path__ + "static/media/Chatbot.f10ab90f47e1d2771b41131dc59bf6f5.svg";
export { ForwardRef as ReactComponent };